import { render } from "./TheAuthUserGenerals.vue?vue&type=template&id=1e471c98"
import script from "./TheAuthUserGenerals.vue?vue&type=script&lang=js"
export * from "./TheAuthUserGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__